import { Navigate } from 'react-router';

import { ANY_SPORT_PLAY_BOARDS_PRO } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const CareerRedirectPage = () => {
  const { generateSportContextPath } = useSportContext();

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_PLAY_BOARDS_PRO)}
      replace
    />
  );
};

export default CareerRedirectPage;
